import { createEntry, insertCss } from "@/helpers/entriesHelper";
import DetailView from "@/views/DetailView/DetailView.vue";
createEntry(DetailView, "eopoi-dv-widget");
insertCss();
